export class PatientHealthcareAgreement {
    public idPatientHealthcareAgreement: number;
    public idHealthcareAgreement: number;
    public idPlan: number;
    public healthcareAgreementCardNumber: string;
    public healthcareAgreementExpirationDate: Date;
    public datetimeInclusion: Date;
    public idPatient: number;
    public isDeleted: boolean;
}